function SendAPIRequest( url, method, params, customHeaders, cb )
{
    var xhr = new XMLHttpRequest( );   

    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            //console.log( "rx response " + xhr.responseText );
            if ( cb )
            {
                var parsed;

                var ct = xhr.getResponseHeader( "Content-Type" );
                if ( ( ct ) && ( ct.indexOf( "json" ) >= 0 ) && ( xhr.responseText ) )
                {
                    try
                    {
                        parsed = JSON.parse( xhr.responseText );
                    }
                    catch ( e )
                    {
                        console.log( "error parsing JSON response : " + e.stack );
                    }
                }

                cb( xhr, parsed );
            }
            else
            {
                if ( xhr.status == 200 )
                {
                    window.location.reload( );
                }
            }
        }
    };

    if ( params )
    {
        xhr.open( method, url, true );
        xhr.setRequestHeader( "Content-Type", "application/json" );

        if( customHeaders && customHeaders.length )
        {
            AddCustomHeaders( xhr, customHeaders );
        }

        xhr.send( JSON.stringify( params ) );
    }
    else
    {
        console.log( "Really Sending request to " + url );
        xhr.open( method, url, true );
        if( customHeaders && customHeaders.length )
        {
            AddCustomHeaders( xhr, customHeaders );
        }
        xhr.send( );
    }
}

function AddCustomHeaders( xhr, customHeaders )
{
    for( var i = 0; i < customHeaders.length; i++ )
    {
        var customHeader = customHeaders[ i ];
        xhr.setRequestHeader( customHeader.header, customHeader.value );
    }
}


function scrollExecute( ) 
{
    if ( document.querySelector( "#paginate_more" ) ) 
    {
        var loadingRect = document.querySelector( "#paginate_more" ).getBoundingClientRect( );
        var heightTrigger = window.innerHeight * 0.75;
        if ( heightTrigger > loadingRect.y ) 
        {
            var scrollNode = document.querySelector( '#paginate_more' );
            var scrollURL = document.querySelector( '#paginate_more a' ).getAttribute( "href" );
            if ( scrollNode && scrollNode.offsetParent !== null ) 
            {
                SendAPIRequest( scrollURL, 'GET', null, null, function ( xhr, response ) 
                {
                    if ( xhr.readyState === 4 && xhr.status === 200 ) 
                    {
                        var temp = document.createElement( 'div' );
                        temp.innerHTML = xhr.response;

                        // Remove loading feedback
                        var nextElement = scrollNode.nextElementSibling;
                        if ( nextElement ) 
                        {
                            nextElement.remove( );
                        }

                        // Extract the products from the response
                        var filteredData = temp.querySelectorAll( ".product-grid__item" );
                        console.log( filteredData );

                        // Append the products to the product list container
                        var productGridColTemplate = document.querySelector( '#product-grid-col-template' );

                        // Loop through filteredData and append each element to productGridColTemplate
                        for ( var i = 0; i < filteredData.length; i++ ) 
                        {
                            productGridColTemplate.appendChild( filteredData[ i ] );
                        }

                        // Check if there's a next page
                        var nextPageLink = temp.querySelector( '#paginate_more a' );
                        if ( nextPageLink && nextPageLink.getAttribute( "href" ) ) 
                        {
                            // Update the URL for the next page
                            var nextPageURL = nextPageLink.getAttribute( "href" );
                            document.querySelector( '#paginate_more a' ).setAttribute( 'href', nextPageURL );
                            scrollNode.style.display = 'block';
                        } else 
                        {
                            // Hide the pagination if there are no more pages
                            scrollNode.remove( );
                        }
                    }
                });
            }
        }
    }
}


document.addEventListener( "DOMContentLoaded", function ( ) 
{
    var paginateMore = document.querySelector( '#paginate_more' );
    if( !paginateMore )
    {
        return;
    }
    if ( !paginateMore.offsetParent )
    {
        paginateMore.style.display = 'none';
    }
    var scrollTimer;

    window.addEventListener( 'scroll', function( )
    {
        clearTimeout( scrollTimer );

        scrollTimer = setTimeout( function ( ) 
        {
            scrollExecute( );

            var nextPageLink = document.querySelector( '#paginate_more a');

            if ( !nextPageLink )
            {
                return;
            }

            var nextPageURL = nextPageLink.getAttribute( 'href' );

            if ( nextPageURL ) 
            {
                paginateMore.style.display = 'block';
            }
        }, 200);
    });
});



